import { render, staticRenderFns } from "./nested_route_app.vue?vue&type=template&id=0a3b5734"
import script from "./nested_route_app.vue?vue&type=script&lang=js"
export * from "./nested_route_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports